import { createStore } from "vuex";
import mutations from "./mutations";

const store = createStore({
  mutations: mutations,
  // plugins: process.env.NODE_ENV !== "production" ? [createLogger()] : [],
  getters: {
    isNorthGermany: (state) => {
      if (["0", "1", "2", "3", "4"].includes(state.user.Zip?.charAt(0))) {
        return true;
      } else {
        return false;
      }
    },
    cases: (state) => {
      const result = {};
      for (const [index, file] of state.files.entries()) {
        const fileCaseId = file.Notes?.CaseId;
        if (fileCaseId) {
          if (result[fileCaseId]) {
            result[fileCaseId].files.push(index);
          } else {
            result[fileCaseId] = {};
            result[fileCaseId].files = [index];
          }
        }
      }
      return result;
    },
    casesById: (state) => {
      const result = {};
      for (const item of state.cases) {
        result[item.Id] = item;
      }
      return result;
    },
    conversationFiles: (state) => {
      const result = [];
      for (const conversation of state.conversations) {
        for (const message of conversation.messages) {
          if (message.File) {
            result.push({
              Name: message.File,
              Date: message.Date,
              CaseId: conversation.caseId,
              MessageId: message.MessageId,
              Partner: message.Partner,
            });
          }
        }
      }
      result.sort((a, b) => {
        const aDate = new Date(a.Date);
        const bDate = new Date(b.Date);
        if (aDate && bDate) {
          return bDate - aDate;
        }
      });
      return result;
    },
    conversationsMessageCount: (state) => {
      const result = { count: 0, conversations: {} };
      for (const conversation of state.conversations) {
        result.conversations[conversation.caseId] = { count: 0 };
        for (const message of conversation.messages) {
          if (message.Partner && !message.Read) {
            result.conversations[conversation.caseId].count++;
            result.count++;
          }
        }
      }
      return result;
    },
  },
  state() {
    return {
      isLoggedIn: false,
      errors: {},
      user: {},
      cases: [],
      errorMessage: "",
      showErrorMessage: false,
      loadingCount: 0,
      maxLoadingDuration: 20 * 1000,
      showLoading: false,
      showOrthodonticsModal: false,
      isScrolledTop: true,
      openMenu: false,
      closeMenu: { value: false, keepModal: false },
      showPolicyNumber: false,
      painarea: { selectedMap: "", selectedArea: "", markers: [] },
      painareaSelectedMapHistory: [],
      spreadarea: { selectedMap: "", selectedArea: "", markers: [] },
      isImageMapChanged: false,
      roodieChecks: {},
      resetHomeView: { value: false, force: false },
      routeAfterLogin: null,
      files: [],
      conversations: [],
      doctors: {
        doctors: [],
        appointments: [],
        proposed: [],
      },
      isStaging:
        process.env.VUE_APP_ORIGIN === "https://stage.roodie-health.com",
    };
  },
});

export default store;
